import React, { useEffect } from 'react';
import { useState } from 'react';
import { Button, Modal } from 'tea-component';

import '../styles/index.scss';
import { getLocale, useIntl } from 'umi';

export default function tipsModal(props) {
  const { formatMessage } = useIntl();
  const locale = getLocale();

  const {
    value,
    setValue,
    tips = {
      en: 'The GPT report you requested is ready. The report will be shown to you after you close the window.',
      zh: '您需要的GPT报告已准备完毕，关闭弹窗后将为您展示报告。',
    },
  } = props;
  const [visible, setVisible] = useState(value);

  useEffect(() => {
    setVisible(value);
  }, [value]);

  const close = () => {
    setVisible(false);
    setValue?.(false);
  };

  const handleConfirm = async () => {
    props.handleConfirm?.();
    close();
  };

  return (
    <>
      <Modal
        visible={visible}
        caption="Notice"
        onClose={close}
        className="dbo-gpt-email-modal"
      >
        <Modal.Body>
          <p className="dbo-gpt-email-tips">
            {locale === 'en-US' ? tips.en : tips.zh}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button type="primary" onClick={handleConfirm}>
            {formatMessage({ id: 'Confirm' })}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
